module.exports = __webpack_public_path__ + "static/media/S2N4-1.1cc07ac6.svg";